import { render } from "./PaymentStatusBadge.vue?vue&type=template&id=6576872b&scoped=true"
import script from "./PaymentStatusBadge.vue?vue&type=script&lang=js"
export * from "./PaymentStatusBadge.vue?vue&type=script&lang=js"

import "./PaymentStatusBadge.vue?vue&type=style&index=0&id=6576872b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6576872b"]])

export default __exports__